import { renderBuildSeedScriptEnvFileTemplate } from '@next-adapter/templates/renderers/commands/seed/build-seed-script.js'
export function buildSeedScript(authBasePath = '/api/admin/auth'): string {
  // Self-contained: inlines DB + auth setup so tsx doesn't need generated aliases.
  // Only relative import is ../lib/db/schema which uses npm packages only.
  return renderBuildSeedScriptEnvFileTemplate({ authBasePath: String(authBasePath) })
}
